// Copyright 2026 IOTA Stiftung.
// SPDX-License-Identifier: Apache-2.0.

/**
 * Configuration for the health service.
 */
export interface IHealthServiceConfig {
	/**
	 * The interval for checking the health of the components.
	 * @default 60000
	 */
	healthCheckInterval?: number;

	/**
	 * The interval for running the application health lifecycle (init, application, teardown).
	 * @default 300000
	 */
	healthCheckApplicationInterval?: number;

	/**
	 * The initial interval for checking the health of the components and setting it in the health service.
	 * This is used to check the health of the components immediately after the service is started.
	 * @default 2000
	 */
	initialInterval?: number;

	/**
	 * Whether to include stack traces in health check error details.
	 * @default false
	 */
	includeErrorStack?: boolean;

	/**
	 * The URL of the module to use for the application health background task.
	 * If not provided, the default healthApplicationTask module will be used.
	 */
	overrideApplicationHealthTaskHandler?: string;

	/**
	 * The component types to exclude from the engine clone used by the application health
	 * background task. Each entry is a regular expression matched against the engine config
	 * type keys, for example "^rightsManagement" or "messaging.*Connector".
	 */
	excludeCloneComponents?: string[];
}
